import React from 'react';
import PropTypes from 'prop-types';

import NumberFormat from 'react-number-format';

const NumberFormatCustom = props => {
  const {
    inputRef,
    onChange,
    onBlur,
    thousandSeparator,
    decimalSeparator,
    decimalScale,
    prefix,
    allowNegative,
    displayType,
    onKeyDown,
    forwardedRef,
    ...other
  } = props;

  return (
    <NumberFormat
      {...other} // eslint-disable-line react/jsx-props-no-spreading
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.floatValue,
          },
        });
        onBlur({
          target: {
            value: values.floatValue,
          },
        });
      }}
      thousandSeparator={thousandSeparator}
      decimalSeparator={decimalSeparator}
      prefix={prefix}
      allowNegative={allowNegative}
      decimalScale={decimalScale}
      displayType={displayType}
    />
  );
};

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func, // eslint-disable-line react/require-default-props
  onChange: PropTypes.func, // eslint-disable-line react/require-default-props
  onBlur: PropTypes.func, // eslint-disable-line react/require-default-props
  thousandSeparator: PropTypes.string,
  decimalSeparator: PropTypes.string,
  decimalScale: PropTypes.number,
  fixedDecimalScale: PropTypes.bool,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  allowNegative: PropTypes.bool,
  displayType: PropTypes.oneOf(['text', 'input']),
  onKeyDown: PropTypes.func,
  forwardedRef: PropTypes.string,
};

NumberFormatCustom.defaultProps = {
  thousandSeparator: ' ',
  decimalSeparator: ',',
  decimalScale: 2,
  fixedDecimalScale: false,
  prefix: '',
  suffix: '€',
  allowNegative: false,
  displayType: 'input',
  forwardedRef: '',
  onKeyDown: e => {
    const { key, target } = e;
    const { selectionStart, value } = target;
    if (key === '.') {
      e.preventDefault();
      target.value = `${value.substr(0, selectionStart)},${value.substr(selectionStart, value.length)}`;
    }
  },
};

export default NumberFormatCustom;
